const NS = 'WoolPublicationListingItemWidget';
const CLS = 'woolPublicationListingItemWidget';

import { handleTruncate } from '../../../../global/js/truncate';

export class WoolPublicationListingItemWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.limit = 120; // reserved limit (characters)
		this.$summary = this.$element.find(`.${CLS}-desc`);
		this.summaryHtml = this.$summary.html();
		this.summaryText = this.$summary.text(); // for comparison without the extra characters from html tags
		this.originalHtml = this.summaryHtml;
		this.$close = this.$element.find(`.close`);
		this.$videoSrc = this.$element.find(`.videoBtn`).data('videosrc');
		this.$iframe = this.$element.find(`.modal iframe`);
		this.$modal = this.$element.find(`.modal`);
		// handle truncate (read more / read less)
		handleTruncate(this);
		
		$(this.$close).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
			$(this.$iframe).attr('src', this.$videoSrc);
		});

		$(this.$modal).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
			$(this.$iframe).attr('src', this.$videoSrc);
		});
	}
}
